/**
 * MonitorCreatePage - Page wrapper for monitor creation wizard
 *
 * Provides a container for the multi-step monitor creation wizard.
 */

import React from 'react';
import { MonitorCreationWizard } from '@/features/monitors/components/MonitorCreationWizard';

/**
 * MonitorCreatePage Component
 *
 * Simple wrapper page that renders the monitor creation wizard
 * in a max-width container with consistent spacing.
 *
 * @example
 * ```tsx
 * <Route path="/monitors/new" element={<MonitorCreatePage />} />
 * ```
 */
export const MonitorCreatePage: React.FC = () => {
  return (
    <div className="container mx-auto max-w-5xl py-8">
      <div className="space-y-2 mb-8">
        <h1 className="text-3xl font-bold">Create Directory Monitor</h1>
        <p className="text-muted-foreground">
          Set up automated directory monitoring to discover and ingest files automatically
        </p>
      </div>
      <MonitorCreationWizard />
    </div>
  );
};
